import React from "react";

const FieldCheckbox = ({ checked, onChange }) => {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e)} // Pass the event object
      className="form-checkbox h-5 w-5 text-blue-800 rounded"
    />
  );
};

export default FieldCheckbox;